// extracted by mini-css-extract-plugin
module.exports = {"itemDescription":"RenderItemDescription_itemDescription__9UPci","episodeDescription":"RenderItemDescription_episodeDescription__1Spqx"};